import { style } from "@vanilla-extract/css";

export const adWrapper = style({
  textAlign: "center",
});
